import toast from 'react-hot-toast';

// 1. 配置表：key 为消息 id，value 为节流间隔（秒）
export const ThrottleConfig = {
    TokenInvalid: 10,
    SaveSuccess: 10,
    NetError: 10,
    CreateProjectError: 10
};

// 2. 记录上次触发时间（毫秒）
const lastShownMap = new Map();

// 3. 默认节流间隔（秒），当 id 未在配置中时使用
const DEFAULT_INTERVAL_SECONDS = 2;

// 4. 核心节流函数
const throttleById = (id, callback) => {
    if (!id) {
        // 没有 id 则直接执行（不节流）
        callback();
        return;
    }

    // 获取该 id 的间隔（秒），转为毫秒
    const intervalSeconds = ThrottleConfig[id] ?? DEFAULT_INTERVAL_SECONDS;
    const intervalMs = intervalSeconds * 1000;

    const now = Date.now();
    const lastTime = lastShownMap.get(id) || 0;

    if (now - lastTime < intervalMs) {
        // 未达到间隔，忽略本次调用
        return;
    }

    // 更新记录并执行回调
    lastShownMap.set(id, now);
    callback();
};

// 5. 导出成功/错误提示
export const success = (message, id) => {
    throttleById(id, () => {
        toast.success(message, {
            icon: '👏',
            style: {
                borderRadius: '10px',
                background: '#5f9f48',
                color: '#fff',
            },
        });
    });
};

export const error = (message, id) => {
    throttleById(id, () => {
        toast.error(message, {
            icon: '❌',
            style: {
                borderRadius: '10px',
                background: '#333',
                color: '#fff',
            },
        });
    });
};

export const info = (message, id) => {
    throttleById(id, () => {
        toast.success(message, {
            style: {
                borderRadius: '10px',
                background: '#5f9f48',
                color: '#fff',
            },
        });
    });
};


export const setThrottleConfig = (id, seconds) => {
    throttleConfig[id] = seconds;
};

export const removeThrottleConfig = (id) => {
    delete throttleConfig[id];
};
